import './Component3.css'
import React from 'react'

const Component3 = () => {
  return (
    <div className='main-3-div'>
        <h1 className='h1-3'>COMPONENT - 3</h1>
    </div>
  )
}
export default Component3